import React from 'react';
import s from './s.module.less';

interface Props {
    name?: string;
    avatar?: string;
    credential?: string;
}

const getInitials = (name?: string) => {
    if (!name) {
        return '';
    }
    const parts = name.trim().split(/\s+/);
    const first = parts[0]?.[0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return `${first}${last}`.toUpperCase();
};

// Provider cell used across the group practice "Practice View" tables: round avatar (with initials
// fallback) + provider name + credential.
const ProviderCell: React.FC<Props> = ({ name, avatar, credential }) => {
    if (!name && !avatar) {
        return <span>-</span>;
    }
    return (
        <div className={s.providerCell}>
            {avatar ? (
                <img src={avatar} alt={name || ''} />
            ) : (
                <span className={s.fallback}>{getInitials(name)}</span>
            )}
            <div className={s.meta}>
                <div className={s.pn}>{name || '-'}</div>
                {credential && <div className={s.pc}>{credential}</div>}
            </div>
        </div>
    );
};

export default ProviderCell;
